<template>
    <svg 
      width="19" 
      height="19" 
      viewBox="0 0 19 19"
      fill="none"
      version="1.1"
      id="svg201"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:svg="http://www.w3.org/2000/svg">
    > 
      <!-- Circle Background -->
      <circle cx="9.5" cy="9.5" r="9.5" fill="#153252"/>
      
      <!-- Minus Symbol (Centered) -->
      <rect
        x="5"
        y="8.5"
        width="9"
        height="2"
        rx="1"
        fill="white"
      />
    </svg>
</template>